import { axiosService } from '..';

export default class UpdateOrganizationBusinessLogo {
    public async execute(input: UpdateOrganizationBusinessLogoDto): Promise<string> {
        const formData = new FormData();
        formData.append(input.imageFile.name, input.imageFile);

        return (await axiosService.instance.post(`businesses/organization/${input.businessId}/update-logo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
    }
}

export class UpdateOrganizationBusinessLogoDto {
    public readonly businessId: number;
    public readonly imageFile: File;

    constructor(businessId: number, imageFile: File) {
        this.businessId = businessId;
        this.imageFile = imageFile;
    }
}

export const updateOrganizationBusinessLogo = new UpdateOrganizationBusinessLogo();
